module.exports = __webpack_public_path__ + "img/folder-image.72744169.svg";